export default {"src":"/_next/static/image/public/images/flags/flag_595.c093eb9e180e90d545a19e9bbf51f44a.svg","height":16,"width":24};